export const environment = {
  production: true,
  apiUrl: "/api/",
  webSocketUrl: "https://webhook.site/PusherCommandReceiver",
  pusherChannelsKey: "9aef012304197ba34163",
  pusherChannelsCluster: "eu",
  pusherChannelsEventName: "general",
};
